import { useState, forwardRef } from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import inputPlaceholder from '../styles/mixin/inputPlaceholder';

const Searchbox = forwardRef(
  ({ onSearch, autoFocus = false, disabled, ...props }, ref) => {
    const [keyword, setKeyword] = useState('');

    const handleSearch = (keyword) => {
      if (onSearch) onSearch(keyword);
    };

    const handleKeyup = (event) => {
      if (event.keyCode === 108 || event.keyCode === 13) {
        handleSearch(keyword);
      }
    };

    const handleClear = () => {
      setKeyword('');
      handleSearch('');
    };

    return (
      <Wrapper {...props}>
        <FaSearch
          onClick={() => {
            handleSearch(keyword);
          }}
          role='button'
          aria-label='search button'
        />
        <Input
          type='text'
          placeholder='Search'
          autocomplete='false'
          value={keyword}
          onChange={(event) => setKeyword(event.target.value)}
          onKeyUp={handleKeyup}
          autoFocus={autoFocus}
          disabled={disabled}
          ref={ref}
        />

        {keyword && (
          <MdClose
            onClick={handleClear}
            role='button'
            aria-label='clear button'
          />
        )}
      </Wrapper>
    );
  },
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 36px;
  background: var(--color-background1);
  border-radius: var(--border-radius-l);
  padding: 0 calc(var(--spacing-s) + var(--font-body1) + var(--spacing-xs)) 0
    var(--spacing-s);

  > svg {
    font-size: var(--font-body1);
    color: var(--font-on-mute);

    &:first-child {
      margin-right: var(--spacing-xs);
    }

    &:last-child {
      position: absolute;
      right: var(--spacing-s);
    }
  }

  ${({ border }) =>
    border && 'border: var(--border-width) solid var(--border-color);'}
`;

const Input = styled.input`
  background: transparent;
  border: none;
  font-size: var(--font-body1);
  color: var(--font-on-background);
  outline: none;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${inputPlaceholder`
    color: var(--font-on-mute);
  `}
`;

export default Searchbox;
